import {
  clampMpmAssignmentsToCapacity,
  normalizeMpmState,
  withMpmAmplifierPanelsUnlocked,
  withMpmAmplifierUpgradesUnlocked,
  withMpmHovGainUpgradesUnlocked,
  withMpmMHovExecutionUnlocked,
  withMpmNHovExecutionUnlocked,
  withMpmOHovExecutionUnlocked,
  type MpmState,
} from "./mpmState";

export interface MpmUnlockIntent {
  readonly hovGainUpgradesUnlocked: boolean;
  readonly mhovExecutionUnlocked: boolean;
  readonly amplifierPanelsUnlocked: boolean;
  readonly amplifierUpgradesUnlocked: boolean;
  readonly nhovExecutionUnlocked: boolean;
  readonly ohovExecutionUnlocked: boolean;
}

export interface MpmUnlockAdoptionInput {
  readonly state: MpmState;
  readonly sources: readonly MpmUnlockIntent[];
  readonly mpCapacity: number;
  readonly mpCapacityInitialized: boolean;
}

export function createNeutralMpmUnlockIntent(): MpmUnlockIntent {
  return {
    hovGainUpgradesUnlocked: false,
    mhovExecutionUnlocked: false,
    amplifierPanelsUnlocked: false,
    amplifierUpgradesUnlocked: false,
    nhovExecutionUnlocked: false,
    ohovExecutionUnlocked: false,
  };
}

export function composeMpmUnlockAdoption(
  input: MpmUnlockAdoptionInput,
): MpmState {
  const composed = input.sources.reduce<MpmUnlockIntent>(
    (next, source) => ({
      hovGainUpgradesUnlocked:
        next.hovGainUpgradesUnlocked || source.hovGainUpgradesUnlocked,
      mhovExecutionUnlocked:
        next.mhovExecutionUnlocked || source.mhovExecutionUnlocked,
      amplifierPanelsUnlocked:
        next.amplifierPanelsUnlocked || source.amplifierPanelsUnlocked,
      amplifierUpgradesUnlocked:
        next.amplifierUpgradesUnlocked || source.amplifierUpgradesUnlocked,
      nhovExecutionUnlocked:
        next.nhovExecutionUnlocked || source.nhovExecutionUnlocked,
      ohovExecutionUnlocked:
        next.ohovExecutionUnlocked || source.ohovExecutionUnlocked,
    }),
    createNeutralMpmUnlockIntent(),
  );

  let next = withMpmHovGainUpgradesUnlocked(
    normalizeMpmState(input.state),
    composed.hovGainUpgradesUnlocked,
  );
  next = withMpmMHovExecutionUnlocked(next, composed.mhovExecutionUnlocked);
  next = withMpmAmplifierPanelsUnlocked(next, composed.amplifierPanelsUnlocked);
  next = withMpmAmplifierUpgradesUnlocked(
    next,
    composed.amplifierUpgradesUnlocked,
  );
  next = withMpmNHovExecutionUnlocked(next, composed.nhovExecutionUnlocked);
  next = withMpmOHovExecutionUnlocked(next, composed.ohovExecutionUnlocked);

  if (!input.mpCapacityInitialized) {
    return next;
  }
  return clampMpmAssignmentsToCapacity(next, input.mpCapacity);
}
